var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65533 27.4514H10.822V35.7014V37.2014H12.322H14.9887H16.4887V35.7014V27.4514H23.6553H25.1553V25.9514V22.7014V22.0689L24.7025 21.6274L21.822 18.8189V7.95142H21.9887H23.4887V6.45142V3.20142V1.70142H21.9887H5.322H3.822V3.20142V6.45142V7.95142H5.322H5.48867V18.8189L2.60818 21.6274L2.15533 22.0689V22.7014V25.9514V27.4514H3.65533Z",
    fill: "currentColor",
    stroke: "#22374A",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.cb7f15a01231794c0626efb96977375b.svg";
export { ForwardRef as ReactComponent };